<template>
  <v-row justify="center">
    <v-col cols="12" class="pt-5 px-5">
      <TabellaRegole />
    </v-col>
  </v-row>
</template>
<script>
import TabellaRegole from "@/components/MANUTENZIONE/TabellaRegole.vue";

export default {
  name: "ManutenzioneAttivita",
  components: { TabellaRegole },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>